import { isNumber } from 'lodash'
import qs from 'query-string'

export const routes = {
  me: {
    //feeds: () => '/', 隐藏掉个人关注
    home: () => '/me',
    manageMy: () => '/manageMy',
    archivePosts: () => '/me/archivePosts',
    archiveGroups: () => '/me/archiveGroups',
  },

  users: {
    page: (userId: number | string) => {
      if (!isNumber(userId)) {
        // 使用 email 名作为用户 route
        return `/users/${userId.split('@')[0]}`
      }
      return `/users/${userId}`
    },
  },

  discover: {
    home: () => '/discover',
    posts: () => '/discover/posts',
    groups: (categoryId?: number) =>
      '/discover/groups' +
      (categoryId
        ? '?' +
          qs.stringify({
            categoryId,
          })
        : ''),
  },

  section: {
    newAgoran: () => '/section/newAgoran',
    entertain: () => '/section/entertain',
    updates: () => '/',
  },

  knowledgebase: {
    home: () => '/knowledgebase',
    category: (categoryId: number | string) => `/knowledgebase/categories/${categoryId}`,
    knowledge: (knowledgeId: number | string) => `/knowledgebase/knowledge/${knowledgeId}`,
  },

  tools: {
    home: () => '/tools',
    websites: () => '/tools/websites',
    departments: () => '/tools/departments',
    journal: () => '/tools/journal',
  },

  groups: {
    home: () => '/groups',
    page: (groupId: number | string) => `/groups/${groupId}`,
  },

  posts: {
    page: (postId: number | string) => `/posts/${postId}`,
  },

  search: {
    home: () => '/search',
  },

  notifications: {
    home: () => '/notifications',
  },

  notificationSettings: {
    home: () => '/notification-settings',
  },

  admin: {
    system: () => '/admin/system',
    onboardingUsers: () => '/admin/onboarding/users',
    allPosts: () => '/admin/allPosts',
    impactQuery: () => '/admin/impact',
  },

  statistics: {
    home: () => '/statistics',
  },

  calendar: {
    home: () => '/calendar',
  },

  anniversaryCardManagement: {
    home: () => '/anniversary-card-management',
    validate: () => '/anniversary-card-management-validate',
    redirect: () => '/anniversary-card-redirect',
  },

  annualReport: {
    home: () => '/annual-report',
  },

  taleGpt: {
    home: () => '/TaleGPT',
  },
  gameHub: {
    home: () => '/game-hub',
  },
  menu: () => '/menu',
}
